module.exports = __webpack_public_path__ + "347b797fed76926a841aa524c97f4f73.png";